import { TextField, Button, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';

import './AcronymForm.css';

import AudioPreviewer from '../Document/AudioPreviewer';
import { DocumentTypeObject } from '../../types/AppTypes';
import { AcronymType } from '../../types/AcronymTypes';
import { SyntheticEvent } from 'react';

interface AcronymFormProps {
  acronym: any;
  updateAcronymRow: (acr: AcronymType) => void;
  updatePronounce: (e: SyntheticEvent) => void;
  updateFollowUp: (e: SyntheticEvent) => void;
  updateName?: (e: SyntheticEvent) => void;
  allowSkip: boolean;
  allowAddToDict: boolean;
  canEditField?: boolean;
}

const AcronymForm = ({
  acronym,
  updateAcronymRow,
  updateName,
  updatePronounce,
  updateFollowUp,
  allowSkip,
  allowAddToDict,
  canEditField,
}: AcronymFormProps): JSX.Element => {
  const term = encodeURIComponent(acronym.name);

  const document = new DocumentTypeObject();

  document.speechParams.languageCode = 'en-US';
  document.speechParams.voiceId = 'Joanna';
  document.speechParams.engine = 'neural';
  document.speechParams.domain = '';
  document.speechParams.sampleRate = 24000;
  document.speechParams.prosodyRate = 110;

  return (
    <>
      <div className="LookupHeader">
        <span>
          [
          <a href={`https://corporatefinanceinstitute.com/search/${term}/`} target="_blank" rel="noreferrer">
            CFI
          </a>
          ]
        </span>
        <span>
          [
          <a href={`https://financial-dictionary.thefreedictionary.com/${term}/`} target="_blank" rel="noreferrer">
            TFD
          </a>
          ]
        </span>
        <span>
          [
          <a href={`https://www.acronymfinder.com/Business/${term}.html`} target="_blank" rel="noreferrer">
            AF
          </a>
          ]
        </span>
        <span>
          [
          <a href={`https://www.youtube.com/results?search_query=${term}`} target="_blank" rel="noreferrer">
            YouTube
          </a>
          ]
        </span>
      </div>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Name"
          variant="standard"
          value={acronym.name}
          onChange={updateName}
          inputProps={{ readOnly: !canEditField }}
        />
        <AudioPreviewer text={acronym.name} document={document} autoplay={acronym.type === 'Missing Word'} id="audio-player-1" />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Document id"
          variant="standard"
          value={acronym.documentId}
          inputProps={{ readOnly: true }}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Type"
          variant="standard"
          value={acronym.type}
          inputProps={{ readOnly: true }}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Pronounce"
          variant="standard"
          value={acronym.pronounce}
          onChange={updatePronounce}
        />
        <AudioPreviewer text={acronym.pronounce} document={document} autoplay={false} id="audio-player-2" />
      </FormControl>
      <FormControlLabel
        control={<Checkbox checked={acronym.followUp} onChange={updateFollowUp} className="checkbox" />}
        label="Follow up"
      />
      <div className="stack">
        {allowAddToDict ? (
          <Button className="button" variant="contained" onClick={() => updateAcronymRow({ addToDict: true })}>
            Add to dict
          </Button>
        ) : (
          ''
        )}
        {allowSkip ? (
          <Button className="button" variant="contained" onClick={() => updateAcronymRow({ skip: true })}>
            Skip
          </Button>
        ) : (
          ''
        )}
        <Button className="button" variant="contained" disabled={!acronym.pronounce} onClick={() => updateAcronymRow({})}>
          Add to jargon
        </Button>
      </div>
    </>
  );
};

export default AcronymForm;
